import * as React from 'react';
import {useSelector} from 'react-redux';

// @ts-expect-error
import decapitalize from 'underscore.string/decapitalize';

import {StatsBlockHorizontal} from 'shells/metrics/stats-block-horizontal';

import type {NutshellState} from '../../../store';
import {statComponents} from '../../../ui/entity-list/header/list-summary/list-summary-stat';

import {GAP_SELECT_VALUES_DAY_TO_YEAR} from '../report-constants';
import {getActivitySummarySchema} from '../report-summary';
import * as reportSelectors from '../reports-selectors';

import styles from './activity-stats-bar.module.css';

type Props = {
    currentGapIndex: number;
};

export function ActivityStatsBar(props: Props) {
    const summaryStats = useSelector((state: NutshellState) =>
        reportSelectors.getSummaryStatsStats(state)
    );
    const isSummaryStatsLoading = useSelector((state: NutshellState) =>
        reportSelectors.getSummaryStatsIsLoading(state)
    );

    const statsForStatsBlock = React.useMemo(() => {
        if (!summaryStats) return [];

        const gapValue = GAP_SELECT_VALUES_DAY_TO_YEAR[props.currentGapIndex];
        const gapLabel = decapitalize(
            gapValue ? gapValue.label : GAP_SELECT_VALUES_DAY_TO_YEAR[0].label
        );
        const schema = getActivitySummarySchema(gapLabel);
        if (!schema) return [];

        // coerce into shape expected by StatsBlockHorizontal
        return Object.keys(schema).map((id) => {
            // @ts-expect-error
            const categoryStats = summaryStats[schema[id].key];
            // @ts-expect-error
            const value = categoryStats ? schema[id].getDataFromStat(categoryStats) : null;
            // @ts-expect-error
            const StatComponent = statComponents[schema[id].type];

            return {
                key: id,
                // @ts-expect-error
                title: schema[id].label,
                value: value && value.formatted ? <StatComponent value={value} /> : '-',
                isLoading: isSummaryStatsLoading,
            };
        });
    }, [summaryStats, isSummaryStatsLoading, props.currentGapIndex]);

    return (
        <div className={styles.container}>
            {/* @ts-expect-error */}
            <StatsBlockHorizontal stats={statsForStatsBlock} size='normal' hasBorders={false} />
        </div>
    );
}
